interface EmptyPlanCardProps {
  children: React.ReactNode,
}

export function EmptyPlanCard (
  { children }: EmptyPlanCardProps
) {
  return (
    <div className='border rounded-2xl p-4 mt-4 w-full min-w-[450px] h-[147px] bg-gray-50 border-gray-200 flex items-center justify-center'>
      {children}
    </div>
  )
}

EmptyPlanCard.displayName = 'SmartBudget.PlanCard.Empty'
